import React from "react";
import Select, {Creatable} from "react-select"

function renderInput(input, id, type, min, placeholder, disabled, error, touched) {
    if (type === 'textarea') {
        return (
            <textarea
                className={"form-control" + (error && touched ? " is-invalid" : "")}
                {...input} />);
    } else {
        return (
            <input
                className={(type === "checkbox" ? "form-check-input" : "form-control")
                + (error && touched ? " is-invalid" : "")} {...input}
                type={type}
                placeholder={placeholder}
                disabled={disabled}
                min={min} id={id ? id : type === "checkbox" ? input.name : ""}/>
        );
    }
}

export function renderField(field) {
    const {label, input, id, type, placeholder, min, disabled, meta: {touched, error, warning}} = field;
    return (
        <div className="form-group">
            <label className={error && touched ? "text-danger" : ""}>{label}</label>
            {renderInput(input, id, type, min, placeholder, disabled, error, touched)}
            <div>
                {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
            </div>
        </div>
    )
}

export function renderCheckbox(field) {
    const {label, input, type, min, meta: {touched, error, warning}} = field;
    return (
        <div className="form-check">
            {renderInput(input, type, min, error, touched)}
            <label className={"form-check-label" + (error && touched ? " text-danger" : "")}
                   htmlFor={input.name}>{label}</label>
            <div>
                {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
            </div>
        </div>
    )
}


function radioButtonClicked(component, fieldName, selected, disabled) {
    if (!disabled) {
        component.props.change(fieldName, selected);
    }
}

export function renderRadioButtonField(component, field, disabled) {
    const {label, input, meta: {touched, error}} = field;
    if (!component.state.typeHasError && touched && error) {
        component.setState({
            typeHasError: true,
            typeError: error
        });
    } else if (component.state.typeHasError && touched && !error) {
        component.setState({
            typeHasError: false,
            typeError: ''
        });
    }
    return (
        <label
            className={"btn btn-light no-z-index" + (input.checked ? ' active' : '') + (disabled ? ' not-allowed' : '')}
            onClick={() => radioButtonClicked(component, input.name, input.value, disabled)}>
            <input className="form-check-input" type="radio" {...input} disabled={disabled}/>
            {label}
        </label>
    );
}

export function renderSelect(field) {
    const {label, input, options, labelKey, valueKey, simpleValue, placeholder, openOnFocus, multi, divClassName,
    meta: {error, touched, warning}} = field;

    return (
        <div className={divClassName ? divClassName : "form-group"}>
            <label className={error && touched ? "text-danger" : ""}>{label}</label>
            <Select
                name={input.name}
                className={(error && touched ? " dropdown-invalid" : "")}
                onChange={input.onChange}
                openOnFocus={openOnFocus}
                simpleValue={simpleValue}
                placeholder={placeholder}
                options={options}
                multi={(!!multi)}
                value={input.value}
                labelKey={labelKey}
                valueKey={valueKey}
            />
            <div>
                {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
            </div>
        </div>
    );
}

export function renderCreatable(field) {
    const {label, input, options, labelKey, valueKey, simpleValue, placeholder, openOnFocus, multi, divClassName,
        meta: {error, touched, warning}, onChange} = field;

    return (
        <div className={divClassName ? divClassName : "form-group"}>
            <label className={error && touched ? "text-danger" : ""}>{label}</label>
            <Creatable
                name={input.name}
                className={(error && touched ? " dropdown-invalid" : "")}
                onChange={onChange && typeof onChange === 'function' ? onChange : input.onChange}
                openOnFocus={openOnFocus}
                simpleValue={simpleValue}
                placeholder={placeholder}
                options={options}
                multi={(!!multi)}
                value={input.value}
                labelKey={labelKey}
                valueKey={valueKey}
            />
            <div>
                {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
            </div>
        </div>
    );
}

export function renderErrorAlert(submitFailed, error, stateSubmitError) {
    if (submitFailed && error) {
        return (
            <div className="alert alert-danger float-left ml-4 custom-alert" role="alert">
                {error}
            </div>
        );
    } else if (stateSubmitError){
        return (
            <div className="alert alert-danger float-left ml-4 custom-alert" role="alert">
                {stateSubmitError}
            </div>
        );
    } else {
        return (<div />);
    }
}



// WEBPACK FOOTER //
// ./src/components/Common/RenderFieldTypes.js